<template>
  <div class="w-100 px-4">
    <div>
      <h1>{{title}}</h1>
      <h2>{{titleSub}}</h2>
    </div>
    <ul>
      <li class="text-left" v-for="(data, index) in dataList">
        <a :href="data.buttonUrl">{{data.buttonName}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    props: {
      title: {
        type: String
      },
      titleSub: {
        type: String
      },
      dataList: {
        type: Array
      }
    },
  };

</script>
